import Axios from 'axios'
import React, { Component } from 'react'
import { getUser } from '../../actions/session'
import { RATEDECK_LISTING } from '../../config/rest_endpoints'
import Container from '../common/application_container'
import CustomLoader from '../common/loader'
import CustomModal from '../common/modal'
import RateDeckAddForm from './addForm'
import Pagination from "react-js-pagination";



class RateDeckListing extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User:getUser(),
            tableData:[],
            isGetting:false,
            isModal:false,
            activePage: 1,
            itemsCount: 10,
            totalCount: null,
        }
        this.openModal = this.openModal.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.getRatedeckList = this.getRatedeckList.bind(this)
        this.handlePageChange = this.handlePageChange.bind(this)
    }

    componentDidMount() {
        this.getRatedeckList()
    }

    openModal() {
        this.setState({isModal:true})
    }

    closeModal() {
        this.setState({isModal:false})
    }

    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        }, () => {
            this.getRatedeckList()
        });
    }

    getRatedeckList() {
        const {User,activePage,itemsCount} = this.state
        this.setState({isGetting:true})
        var headers = { 'Authorization': "Bearer " + User.token }
        Axios.get(`${RATEDECK_LISTING}?page=${activePage}&limit=${itemsCount}`,{headers}).then(res=>{
            if(res) {
                console.log('res :>> ', res);
                var resp = res.data.data
                this.setState({tableData:resp, isGetting:false, totalCount:res.data.pageinfo.totalCount})
                console.log('totalcount :>> ', this.state.totalCount);
            }
        }).catch(err=>{
            console.log('err :>> ', err);
        })
    }

    renderTableData() {
        const {tableData} = this.state
        if(tableData === null ) {
            return (
                <div className="ml-4 mt-2">
                    <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                    <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                </div>
            )
        }
        else {
            return tableData.map((row,idx)=>{
                return(
                    <tr key={idx}>
                        <td>{row.tpID}</td>
                        <td>{row.csvName}</td>
                        <td>{row.path}</td>
                        <td>{row.status}</td>
                        <td>{row.connectFee}</td>
                        <td>{row.initialInc}</td>
                        <td>{row.subsequentInc}</td>
                        <td>{row.roundingMethod}</td>
                        <td>{row.roundingDigits}</td>
                        <td>{row.RecordTime}</td>
                    </tr>
                )
            })
        }
    }
    
    render() {
        const {isGetting, isModal} = this.state
        let addRateDeck = {
            details: {
                info: "Add RateDeck",
                msg: <RateDeckAddForm listing={this.getRatedeckList} close={this.closeModal} />
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeModal },
            cancelBtn: { label: "Cancel", action: this.closeModal }
        }

        return (
            <Container title="Rate Deck" icon="fa fa-bars">
                <CustomModal
                    visibility={isModal}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    details={addRateDeck.details}
                    modalSize={"large"}
                    showBtns={false}
                    cancelBtn={addRateDeck.cancelBtn}
                    crossBtn={addRateDeck.crossBtn}
                />
                <div className="card card-body border-top-success border-bottom-success">
                    <div className="card-header header-elements-inline">
                        <h3 className="card-title">Rate Deck Table</h3>
                        <div className="header-elements">
                            <button type="submit" className="btn bg-blue ml-3" onClick={this.openModal}>Add RateDeck <i className="fas fa-plus ml-2"></i></button>
                        </div>
                    </div>
                    <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                        <div className="datatable-header">
                            <div id="DataTables_Table_0_filter" className="dataTables_filter">
                                <label className="fs-16"><span>Search :</span>
                                    <input type="search" className="" placeholder="Type to filter..."  onChange={this.searchSpace} aria-controls="DataTables_Table_0" />
                                </label>
                            </div>
                        </div>
                        <div className="datatable-scroll " style={{ overflowX: 'auto' }}>
                            <table className="table datatable-basic table-striped bg-light border dataTable no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                <thead>
                                    <tr className="bg-dark">
                                        <th>Id</th>
                                        <th>Csv Name</th>
                                        <th>Path</th>
                                        <th>Status</th>
                                        <th>Connect Fee</th>
                                        <th>Initial Inc</th>
                                        <th>Subsequent Inc</th>
                                        <th>Rounding Method</th>
                                        <th>Rounding Digits</th>
                                        <th>Record Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                   {isGetting ? <CustomLoader /> :this.renderTableData()}
                                </tbody>
                            </table>
                        </div>
                        <div className="datatable-footer mt-1">
                            <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                            {this.state.totalCount > 9 ?
                             <div className="mt-3">
                             <Pagination
                                 activePage={this.state.activePage}
                                 itemsCountPerPage={this.state.itemsCount}
                                 totalItemsCount={this.state.totalCount}
                                 pageRangeDisplayed={5}
                                 onChange={this.handlePageChange.bind(this)}
                             />
                         </div>  :''
                        }
                           
                        </div>
                    </div>
                </div>
            </Container>
        )
    }
}
export default RateDeckListing